import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { toast, ToastContainer } from "react-toastify";
import PromotionReport from "./PromotionReport";

const PromotionReportPrint = () => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [promotedStudents, setPromotedStudents] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [schoolName, setSchoolName] = useState("");
  const [logoImage, setLogoImage] = useState("");

  // Filter states from URL parameters
  const [oldWingId, setOldWingId] = useState(0);
  const [newWingId, setNewWingId] = useState(0);
  const [oldClassId, setOldClassId] = useState(0);
  const [newClassId, setNewClassId] = useState(0);
  const [oldSectionId, setOldSectionId] = useState(0);
  const [newSectionId, setNewSectionId] = useState(0);
  const [registrationNo, setRegistrationNo] = useState("");
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [isActive, setIsActive] = useState(null);

  useEffect(() => {
    document.title = "AGS School Management System - Promotion Report";

    setLoading(true);
    // Get the URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Retrieve individual parameter values
    const oldWing = urlParams.get("OldWing_Id") || 0;
    const newWing = urlParams.get("NewWing_Id") || 0;
    const oldClass = urlParams.get("OldClass_Id") || 0;
    const newClass = urlParams.get("NewClass_Id") || 0;
    const oldSection = urlParams.get("OldSection_Id") || 0;
    const newSection = urlParams.get("NewSection_Id") || 0;
    const regNo = urlParams.get("Student_ID") || "";
    const dateFromStr = urlParams.get("DateFrom") || "";
    const dateToStr = urlParams.get("DateTo") || "";
    const active = urlParams.get("Is_Active") || null;

    // Set the state variables
    setOldWingId(oldWing);
    setNewWingId(newWing);
    setOldClassId(oldClass);
    setNewClassId(newClass);
    setOldSectionId(oldSection);
    setNewSectionId(newSection);
    setRegistrationNo(regNo);
    setDateFrom(dateFromStr !== "" ? dateFromStr : null);
    setDateTo(dateToStr !== "" ? dateToStr : null);
    setIsActive(active !== "" ? active : null);

    fetchPromotedStudents(
      oldWing,
      newWing,
      oldClass,
      newClass,
      oldSection,
      newSection,
      regNo,
      dateFromStr,
      dateToStr,
      active
    );
  }, []);

  const fetchPromotedStudents = (
    oldWingId,
    newWingId,
    oldClassId,
    newClassId,
    oldSectionId,
    newSectionId,
    registrationNo,
    dateFrom,
    dateTo,
    isActive
  ) => {
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: 1,
      pageSize: 10000, // Large number to get all records for printing
      OldWing_Id: oldWingId,
      NewWing_Id: newWingId,
      OldClass_Id: oldClassId,
      NewClass_Id: newClassId,
      OldSection_Id: oldSectionId,
      NewSection_Id: newSectionId,
      Student_ID: registrationNo,
      DateFrom: dateFrom,
      DateTo: dateTo,
      Is_Active: isActive,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Reports/GetPromotedStudentsDetails",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          setPromotedStudents(response.data.ListofRecords);
          setTotalRecords(response.data.totalRecords);
          setSchoolName(response.data.SchoolName);
          setLogoImage(response.data.LogoImage);
          setLoading(false);
        } else {
          setPromotedStudents([]);
          setTotalRecords(0);
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoading(false);
        }
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        toast.error("Network Error", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const renderPromotedStudents = () => {
    if (promotedStudents && promotedStudents.length > 0) {
      return promotedStudents.map((item, index) => {
        const isPageBreak = index > 0 && index % 43 === 0;
        return (
          <tr key={index}>
            <td>{item.Serial_No}</td>
            <td>{item.Student_ID}</td>
            <td>{item.Student_Name}</td>
            <td>{item.Father_Name}</td>
            <td>{moment(item.Date).format("DD-MM-YYYY")}</td>
            <td>{item.OldWing}</td>
            <td>{item.OldClass}</td>
            <td>{item.OldSection}</td>
            <td>{item.NewWing}</td>
            <td>{item.NewClass}</td>
            <td>{item.NewSection}</td>
            <td>{item.PromotedByName}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="12">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  // Create a title based on the filter parameters
  const getReportTitle = () => {
    let title = "Promotion Report";
    if (dateFrom && dateTo) {
      title += ` (${moment(dateFrom).format("DD-MM-YYYY")} to ${moment(
        dateTo
      ).format("DD-MM-YYYY")})`;
    } else if (dateFrom) {
      title += ` (From ${moment(dateFrom).format("DD-MM-YYYY")})`;
    } else if (dateTo) {
      title += ` (To ${moment(dateTo).format("DD-MM-YYYY")})`;
    }
    return title;
  };

  return (
    <>
      <ToastContainer />
      <Page orientation="landscape" size="a4">
        <table className="table table-sm table-bordered table-print">
          <thead>
            <tr>
              <th colSpan={12}>
                <PrintHeader title={getReportTitle()} />
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan="12">
                  <Spinner animation="border" role="status"></Spinner>
                </td>
              </tr>
            ) : (
              <>
                <tr>
                  <th className="text-end" colSpan={12}>
                    Total Records: {totalRecords}
                  </th>
                </tr>
                <tr>
                  <th>Sr. No.</th>
                  <th>ID</th>
                  <th>Student Name</th>
                  <th>Father Name</th>
                  <th>Date</th>
                  <th>Old Wing</th>
                  <th>Old Class</th>
                  <th>Old Section</th>
                  <th>New Wing</th>
                  <th>New Class</th>
                  <th>New Section</th>
                  <th>Promoted By</th>
                </tr>
                {renderPromotedStudents()}
              </>
            )}
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default PromotionReportPrint;
